export const CN_FONT_VERSION = '20260225'
